<!-- 仪表盘 -->
<template>
  <div
    class="mainArea clearfix"
    :style="{height: $store.state.windowHeight - 64 + 'px'}">
    <!-- <MapNavBar :deviceMapList="deviceMapList"></MapNavBar> -->
    <div
    class="MapNavBar"
    :style="{width: $store.state.navBarWidth +'px', height: $store.state.windowHeight + 'px', opacity: $store.state.navBarWidth === 0 ? 0: 1}">

    <!--返回按钮-->
    <i class="return ico ico-round-left-fill" v-if="currentLevelMap !=='country' && keywords === ''" @click="back"></i>

    <!--企业搜索框-->
    <div class="search">
      <el-input v-model="keywords" placeholder="企业名称" clearable>
        <el-button slot="append" icon="el-icon-search" @click="getSpaceDeviceCount('', '')"></el-button>
      </el-input>
    </div>

    <!--显示设备列表-->
    <div class="deviceList">
      <el-table
        :data="currentMapList"
        :height="$store.state.windowHeight - 100"
        stripe
        @row-click="getNewMapList">
        <el-table-column
          :label="currentTableFirstLabel">
          <template slot-scope="scope">
            <div class="deviceMapInfo">
              {{scope.row.area_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="设备数量">
          <template slot-scope="scope">
            <div class="deviceMapInfo">
              {{scope.row.total}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 更多模块连接 -->
    <router-link class="moreLink" to="/Index">更多模块</router-link>
  </div>
    <!-- 地图区域 -->
    <div id="allmap"></div>
  </div>
</template>

<script>
  import MapNavBar from './Layout/MapNavBar.vue'
  import { mapApi } from "../../static/js/api.js"
  import { showToast } from '../../static/js/utility/utility'

  export default {
    data() {
      return {
        keywords: '',
        commonUrl: '#/Map/',
        currentLevelMap:'country',
        currentId: '1',
        currentMapList:[],
        currentTableFirstLabel: '',
        defaultLocation:[113.3948175587587,23.40800372902474]
      }
    },
    components: {
      MapNavBar
    }, 
    mounted(){
      this.mapInit()
    },
    created: async function () {
      this.currentLevelMap = this.$route.params.mapLevel || 'country'
      this.currentId = this.$route.params.id || '1'
    },
    methods: {
      // 地图初始化
      mapInit() {
        // 百度地图API功能
        // console.log(this.currentLevelMap);
        // 根据级别和中心点绘制地（默认获取国内，1）
        this.drawMap(this.currentId)
      },
      // 根据级别和中心点绘制地图
      drawMap(id) {
        // 根据级别和位置,设置当前地图列表
        let mapLevel = this.currentLevelMap
        // 获取相对应地区、空间的设备数量
        this.getSpaceDeviceCount(id, mapLevel)

        switch (mapLevel) {
          case 'country':
            this.currentTableFirstLabel = '省'
            break;

          case 'province':
            this.currentTableFirstLabel = '市'
            break;

          case 'city':
            this.currentTableFirstLabel = '区'
            break;

          case 'area':
            this.currentTableFirstLabel = '公司'
            break;
        
          default:
            break;
        }
      },
      // 获取地区、空间的设备数量
      getSpaceDeviceCount: async function (id, area_level) {
        let vm = this
        let data = {
          id: id,
          area_level: area_level
        }
        data.area_name = vm.keywords === '' ? '' : vm.keywords

        console.log('data', data)

        let res = await mapApi.getSpaceDeviceCount(data)
        if (res.meta.code === 200) {
          vm.currentMapList = res.data
          if (vm.keywords !== '') {
            vm.currentTableFirstLabel = '公司'
          }
          // 循环添加信息点
          vm.addInfoPoint()
        } else {
          showToast(res.meta.message)
        }
      },
      // 添加信息点
      addInfoPoint() {
        let vm = this
        // 创建Map实例
        let map = new BMap.Map("allmap");    
        // 初始化地图,设置中心点坐标和地图级别(默认中心点为广东)
        let centerPoint = [...vm.defaultLocation];
        map.centerAndZoom(new BMap.Point(centerPoint[0],centerPoint[1]), 7);
        //开启鼠标滚轮缩放
        map.enableScrollWheelZoom(true);
        // 循环添加信息点
        // console.log('vm.currentMapList', vm.currentMapList)
        vm.currentMapList.forEach(function (item, index ) {
          // console.log('item', item)
          let point = new BMap.Point(item.longitude, item.latitude);
          let marker = new BMap.Marker(point);  // 创建标注
          map.addOverlay(marker);              // 将标注添加到地图中
          let size = item.area_level === 'province' ? 5 :
                    item.area_level === 'city' ? 11 :
                    item.area_level === 'area' ? 11 : 14
                    console.log('size', size)
          map.centerAndZoom(point, size);
          let opts = {
            width : 100,     // 信息窗口宽度
            height: 100,     // 信息窗口高度
          };

          let windowText = item['area_name'] + ':' + item['total'] + '个';

          // 信息窗口内容
          let windowUrl = vm.commonUrl + item['area_level'] + '/' + item['id'];
          let default_windowInfo = `<div class="infoWindow" style="font-size:14px;line-height:20px;">
            <p class="encoding" style="margin-top:10px;margin-bottom:40px;font-weight: bold;">${windowText}</p>
            <a class="go" href=${windowUrl} style="display:block;width:100%;background-color:#409EFF;color:#fff;text-align:center;border-radius:5px;line-height:25px;margin:5px 0;">
              前往查看
            </a>
          </div>`;
          // 公司信息窗口内容
          let company_windowInfo = `<div class="infoWindow" style="font-size:14px;line-height:20px;">
            <p class="encoding" style="margin-top:10px;margin-bottom:40px;font-weight: bold;">${windowText}</p>
          </div>`;

          let windowInfo = item['area_level'] === 'space_one' ? company_windowInfo : default_windowInfo
          let infoWindow = new BMap.InfoWindow(windowInfo, opts);  // 创建信息窗口对象 
          marker.addEventListener('mouseover', ()=> {
            map.openInfoWindow(infoWindow,point); //开启信息窗口
          });

        })
      },
      //返回上一级
      back(){
        this.$router.go(-1);
      },
      // 点击地址导航栏获取新的列表
      getNewMapList: function (row) {
        console.log('row', row)
        if (row.area_level === 'space_one') {
          return
        }
        // 路由跳转
        let windowUrl = this.commonUrl + row.area_level + '/' + row.id;
        window.location.href= windowUrl;
      },
    },
    watch: {
      // 监听id的变化，获取新的设备列表
      '$route.params.id': function (newVal) {
        console.log('newVal', newVal, this.$route.params.mapLevel)
        if (newVal) {
          this.currentLevelMap = this.$route.params.mapLevel
          this.drawMap(newVal)
        } else {
          this.currentLevelMap = 'country'
          this.drawMap('1')
        }
      },
      // 监听搜索字段的变化，清空显示默认设备信息
      'keywords': function (newVal) {
        if (newVal === '') {
          this.mapInit()
        }
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
// 导航
.MapNavBar {
  width: 256px;
  position: absolute;
  top: 0;
  left: 0;  
  .return {
    margin: 7.5px 0;
    font-size: 30px;
    font-weight: bold;
    color: #555555;
    position: absolute;
    left: 15px;
    top: 40px;
    z-index: 2;
  }
  .deviceList {
    .table {
    }
    .deviceMapInfo {
      padding: 3px;
      margin: -3px;
    }
  }
  .moreLink {
    line-height: 20px;
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}

  .Map {
    .mapNav {
      width: 265px;
      float: left;
      background-color: red;
    }
    .mapRightArea {
      background-color: #cccccc;
    }
  }

  #allmap{
    width: 100%;
    height: calc(100vh - 64px);
    overflow: hidden;
  }

  .chooseInfo {
    margin: 3%;
    width: 400px;
  }
  .saveButton {
    margin-top: 5%;
  }
  
</style>




// WEBPACK FOOTER //
// src/components/Map.vue